import React from "react";
import DropDownNav from "../../dropdown/dropdownNav";
import ItemNav from "../topnav/itemNav";
import "./style/topnav.css";
import { assets } from "../../../assets/assets";
import { useZone } from "../../../context/ZoneContext";

function TopNavBar({
  lang,
  btnLang,
  onCallbackClick,
  onShowRadiusClick,
  hideShowRadius,
  onToggleOverlay,
  isOverlayHidden,
  page,
}) {
  const { project, loading } = useZone();
  const isExplore =
    page.includes("/villa/") || page.startsWith("/explore-tour");
  const isInteractive = page.startsWith("/interactive-tour");

  return (
    <div
      dir={lang === "ar" ? "rtl" : "ltr"}
      className={`top-navbar d-flex justify-content-center align-items-center topnav-container
        ${isExplore ? "topnav-explore" : ""}
        ${isInteractive ? "topnav-interactive" : ""}
        ${!isExplore && !isInteractive ? "fixed-top-" : "explore-mode-fixed"}
      `}
      style={{
        zIndex: "99999",
        background: isExplore ? "transparent" : "",
      }}
    >
      <div
        className={`
              ${
                page.startsWith("/master-plan") ||
                page.startsWith("/explore-tour") ||
                page.startsWith("/interactive-tour")
                  ? "col-lg-3 col-xl-2 d-none d-lg-flex"
                  : "col-md-4 col-lg-3 d-none d-md-flex"
              }
              justify-content-md-end
              justify-content-center
              align-items-center
              position-item-nav
            `}
      >
        <ItemNav
          lang={lang}
          className="with-bg"
          onCallbackClick={onCallbackClick}
          onShowRadiusClick={onShowRadiusClick}
          hideShowRadius={hideShowRadius}
          onToggleOverlay={onToggleOverlay}
          isOverlayHidden={isOverlayHidden}
          btnLang={btnLang}
          page={page}
        />
      </div>
      <nav className="navbar navbar-expand-lg col-12 col-md-12 p-0">
        <div className="container-fluid justify-content-between p-0">
          <div className="logo col-lg-3 col-md-4 col-12 justify-content-between">
            <div className="navbar-brand m-0 p-0">
              <a href="/">
                <img src={assets.G_W} alt="" />
              </a>
            </div>
            <div className="dropdown-container justify-content-end justify-content-md-start m-0 p-0">
              <DropDownNav lang={lang} data={loading ? null : project} />
            </div>
          </div>
        </div>
      </nav>
    </div>
  );
}

export default TopNavBar;
